import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import geobuf from 'geobuf';
import Pbf from 'pbf';
import { Layer, Source } from 'react-map-gl/mapbox';

const s3UrlBase = 'https://seagull-visualization-layers.s3.us-east-2.amazonaws.com';

const WavePeriod = (props) => {
  const {
    UTCPath,
    selectedLake,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [periodLayers, setPeriodLayers] = useState([]);

  const fetchOfs = async (ofs) => {
    const ofsUrl = `${s3UrlBase}${UTCPath}/${ofs}-waves-period-500m.pbf`;
    const ofsResponse = await fetch(ofsUrl);
    const ofsData = await ofsResponse.arrayBuffer();
    return geobuf.decode(new Pbf(ofsData));
  };

  const fetchData = async (selectedLake) => {
    if (selectedLake.length > 0) {
      const ofs = `l${selectedLake[0].toLowerCase()}`;
      const ofsData = await fetchOfs(ofs);
      setPeriodLayers([
        {
          lake: 'primaryLakePeriod',
          sourceId: 'primaryLakePeriodSource',
          data: ofsData,
        },
      ]);
    } else if (selectedLake.length === 0) {
      const [leofsPeriodData, lhofsPeriodData, lmofsPeriodData, loofsPeriodData, lsofsPeriodData] = await Promise.all([
        fetchOfs('le'),
        fetchOfs('lh'),
        fetchOfs('lm'),
        fetchOfs('lo'),
        fetchOfs('ls'),
      ]);
      setPeriodLayers([
        {
          lake: 'primaryLakePeriod',
          sourceId: 'primaryLakePeriodSource',
          data: leofsPeriodData,
        },
        {
          lake: 'lhofsPeriod',
          sourceId: 'lhofsPeriodSource',
          data: lhofsPeriodData,
        },
        {
          lake: 'lmofsPeriod',
          sourceId: 'lmofsPeriodSource',
          data: lmofsPeriodData,
        },
        {
          lake: 'loofsPeriod',
          sourceId: 'loofsPeriodSource',
          data: loofsPeriodData,
        },
        {
          lake: 'lsofsPeriod',
          sourceId: 'lsofsPeriodSource',
          data: lsofsPeriodData,
        },
      ]);
    } setIsLoading(false);
  };

  useEffect(() => {
    if (!isLoading) {
      setIsLoading(true);
      fetchData(selectedLake)
        .then(() => {
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  }, [selectedLake, UTCPath]);

  const periodStyle = {
    type: 'fill',
    beforeId: 'waterway-label',
    paint: {
      'fill-color': 'rgba(0, 0, 0, 0)',
      'fill-opacity': 0.0,
      'fill-antialias': false,
    },
  };
  return (
    <>
      {periodLayers.map((waveLayer, index) => (
        <Source
          id={waveLayer.sourceId}
          type="geojson"
          data={waveLayer.data}
          key={index}
        />
      ))}
      {periodLayers.map((waveLayer, index) => (
        <Layer
          id={waveLayer.lake}
          source={waveLayer.sourceId}
          {...periodStyle}
          key={index}
        />
      ))}
    </>
  );
};

WavePeriod.propTypes = {
  UTCPath: PropTypes.string,
  selectedLake: PropTypes.string,
};

WavePeriod.defaultProps = {
  UTCPath: '',
  selectedLake: '',
};

export default WavePeriod;
